import React from 'react';
import { FadeIn } from './FadeIn';
export function TomosSection() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — VISUAL STOP-SCROLL',
    subtitle: 'Creativos que detienen el scroll',
    desc: 'Prompts para imágenes, videos, carruseles y UGC que capturan la atención en el feed de Meta en menos de 1.3 segundos.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — UGC & SOCIAL PROOF',
    subtitle: 'Confianza que convierte',
    desc: 'Prompts para contenido generado por usuarios, testimonios visuales y prueba social que convierte escépticos en compradores.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — MEDIA BUYING SENIOR',
    subtitle: 'Estructura de campaña que escala',
    desc: 'Prompts para arquitectura de campañas, segmentación avanzada, retargeting y lookalike audiences que optimizan el presupuesto.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — DATA & PROFIT ANALYSIS',
    subtitle: 'Decisiones basadas en datos',
    desc: 'Prompts para análisis de métricas, optimización de ROAS, diagnóstico de campañas y escalado con metodología.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — COPYWRITING DE CONVERSIÓN',
    subtitle: 'Palabras que venden',
    desc: 'Prompts para copy PAS, AIDA, headlines, CTAs y secuencias de anuncios para tráfico frío, tibio y caliente.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — ESTRUCTURA & ESCALADO',
    subtitle: 'Del primer peso al presupuesto grande',
    desc: 'Prompts para diseño de funnels, estrategias de escalado, gestión de cuentas de alto ticket y reportes ejecutivos.'
  }];
  return <section className="py-12 px-4 max-w-5xl mx-auto" data-id="element-344">
      <FadeIn data-id="element-345">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-346">
          <span className="text-4xl" data-id="element-347">🤖</span> TOMO 1 A TOMO 6 — 6 TOMOS
          COMPLETOS
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-348">
        {tomos.map((tomo, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-349">
            <div className="bg-gray-900 border border-gray-800 hover:border-green-500/50 transition-colors rounded-xl p-6 h-full flex flex-col" data-id="element-350">
              <div className="text-4xl mb-4" data-id="element-351">{tomo.icon}</div>
              <h3 className="text-xl font-bold text-green-400 mb-1" data-id="element-352">
                {tomo.title}
              </h3>
              <p className="text-sm font-bold text-white mb-3" data-id="element-353">
                {tomo.subtitle}
              </p>
              <p className="text-gray-300 font-medium leading-relaxed flex-grow" data-id="element-354">
                {tomo.desc}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </section>;
}